import React from "react";
import Lightbox from "yet-another-react-lightbox";
import {
  Download as DownloadPlugin,
  Zoom,
} from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/styles.css";
import { IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

const SingleImageViewer = (props) => {
  const { image, visible, onClose, options, styles } = props;

  return (
    <Lightbox
      open={visible}
      close={onClose}
      slides={[{ src: image }]}
      render={{
        buttonClose: () => (
          <IconButton className="bg-[#0000004d] text-white" onClick={onClose}>
            <Close className="text-white" />
          </IconButton>
        ),
      }}
      styles={styles || {}}
      plugins={[DownloadPlugin, Zoom]}
      toolbar={
        options && {
          buttons: [options(0), "close"],
        }
      }
    />
  );
};

export default React.memo(SingleImageViewer, (prevProps, nextProps) => {
  return (
    prevProps.image === nextProps.image &&
    prevProps.visible === nextProps.visible &&
    prevProps.options === nextProps.options
  );
});
